import React from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { COLOR, FONT_SIZE } from '../../../constants/theme';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const AvatarContainer = styled(Avatar)`
  flex: none;
  background: ${COLOR.primaryLight};
  color: ${COLOR.primary};
  font-size: 17px;
  font-weight: 700;
`;

const Name = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: ${COLOR.navy};
`;

const Speciality = styled.div`
  margin-top: 2px;
  font-size: ${FONT_SIZE.body};
  color: ${COLOR.textSecondary};
`;

const buildInitials = (firstName, lastName) =>
  `${firstName || ''}`.charAt(0).toUpperCase() +
  `${lastName || ''}`.charAt(0).toUpperCase();

const ClinicianCard = ({ specialist }) => {
  if (!specialist) return null;

  const { avatarLink, firstName, lastName, speciality } = specialist;
  const initials = buildInitials(firstName, lastName);

  return (
    <Row>
      <AvatarContainer
        size={52}
        src={avatarLink || null}
        icon={!initials && <UserOutlined />}
      >
        {initials}
      </AvatarContainer>
      <div>
        <Name>{`Dr. ${firstName} ${lastName}`}</Name>
        {speciality && <Speciality>{speciality}</Speciality>}
      </div>
    </Row>
  );
};

export default ClinicianCard;
